/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Divider, ListItem, Typography } from '@material-ui/core';
import { WS_ACTION_TYPES } from '../../redux-saga/actionTypes';
import { commands } from '../../constants/index';
import { NoFavoritesRecent, Buttons } from '../index';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: {
    general: { Delete },
  },
} = theme;
const { deleteCommand } = commands;

const ManageFavoriteRecent = ({
  t,
  classes,
  list,
  sendMessageToSocket,
  searchResponse: { totalCount },
}) => {
  const [dolist, setList] = React.useState([]);
  const getCloseTime = data => {
    const [time] = data;
    const { closeTime } = time;
    return closeTime;
  };

  const onClickDelete = index => {
    const newList = list.splice(index, 1);
    setList(newList);
    sendMessageToSocket(deleteCommand(index));
  };

  return (
    <React.Fragment>
      {list.length !== 0 ? (
        <div className={classes.scroll__wheel}>
          {list.map((locations, index) => {
            const {
              id,
              name,
              distanceValue,
              timeValue,
              poi: { open_now, openHours, marketEnabled },
            } = locations;
            return (
              <React.Fragment>
                <ListItem key={id} className={classes.menuItem__container}>
                  <div className={classes.list__container}>
                    <Typography className={classes.left__alphabet}>
                      {String.fromCharCode('A'.charCodeAt() + index)}
                    </Typography>
                    <div className={classes.center__container}>
                      <Typography className={classes.title__text}>
                        {name}
                        {marketEnabled === true ? (
                          <i className={`material-icons ${classes.mp}`}>local_mall</i>
                        ) : (
                          ''
                        )}
                      </Typography>
                      <span className={classes.display__flex}>
                        <Typography className={classes.subtitle}>
                          {open_now
                            ? `${t('poi-list.label.open-now')}`
                            : `${t('poi-list.label.closed')}`}
                        </Typography>
                        <span className={classes.dot}>
                          {open_now ? `${t('poi-list.label.dot')}` : ''}
                        </span>
                        <Typography className={classes.subtitle}>
                          {open_now ? `${t('poi-list.label.closes')}` : ''}
                        </Typography>
                        {open_now ? (
                          <Typography className={classes.close__hour}>
                            {getCloseTime(openHours)}
                          </Typography>
                        ) : null}
                      </span>
                      <span className={classes.display__flex}>
                        <Typography className={classes.subtitle}>{timeValue}</Typography>
                        {distanceValue === undefined ? (
                          ''
                        ) : (
                          <span className={classes.display__flex}>
                            <span className={classes.dot}>{t('poi-list.label.dot')}</span>
                            <Typography className={classes.subtitle}>{distanceValue}</Typography>
                          </span>
                        )}
                      </span>
                    </div>
                    <div className={classes.remove__icon__container}>
                      <img
                        className={classes.remove_icon}
                        src={Delete}
                        alt="Delete"
                        onClick={() => onClickDelete(index)}
                      />
                    </div>
                  </div>
                </ListItem>
                <Divider />
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <NoFavoritesRecent />
      )}
      {list.length < totalCount ? <Buttons /> : null}
    </React.Fragment>
  );
};

ManageFavoriteRecent.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  list: PropTypes.array,
  sendMessageToSocket: PropTypes.func.isRequired,
  searchResponse: PropTypes.object.isRequired,
};

ManageFavoriteRecent.defaultProps = {
  list: [],
};

const mapStateToProps = ({ poi }) => ({
  list: poi.favorite_recent_list,
  searchResponse: poi.search_response,
});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(ManageFavoriteRecent)),
);
